          function addToCart(variantId) {
            var formData = {
              'id': variantId,
              'quantity': 1
            };

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              // Verifica se a resposta foi bem-sucedida
              if (!response.ok) {
                throw new Error('Erro ao adicionar o produto ao carrinho');
              }
              // Atualiza o carrinho na página
              return response.json();
            })
            .then(data => {
              // Redireciona para a página do carrinho
              window.location.href = '/cart';
            })
            .catch(error => {
              console.error('Erro:', error);
            });
          }